const utils = {
  isNativeWebview() {
    // TODO: we need something stronger then this, the user agent is controlled from the native wrapper
    return (
      navigator.userAgent.indexOf("; wv)") !== -1 ||
      localStorage.selectedEnv === "native"
    )
  },

  uuid() {
    return URL.createObjectURL(new Blob([])).slice(-36)
  },

  setColorOpacity(hex, opacity) {
    // Return red to indicate error for invalid hex color
    if (!/^#(?:[0-9a-f]{3}){1,2}$/i.test(hex)) return `rgba(255, 0, 0, 1)`

    // Convert shorthand hex form ("#03F") to full ("#0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b
    })

    // Convert to rgb and add opacity
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    const r = parseInt(result[1], 16)
    const g = parseInt(result[2], 16)
    const b = parseInt(result[3], 16)
    return `rgba(${r}, ${g}, ${b}, ${opacity})`
  },

  humanFileSize(bytes, si = true, dp = 1) {
    const thresh = si ? 1000 : 1024

    if (Math.abs(bytes) < thresh) {
      return bytes + " B"
    }

    const units = si
      ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
    let u = -1
    const r = 10 ** dp

    do {
      bytes /= thresh
      ++u
    } while (
      Math.round(Math.abs(bytes) * r) / r >= thresh &&
      u < units.length - 1
    )

    return bytes.toFixed(dp) + " " + units[u]
  },

  abbreviateNumber(number) {
    return Intl.NumberFormat("en-US", {
      notation: "compact",
      maximumFractionDigits: 0,
    }).format(parseInt(number))
  },

  sleep(timeout) {
    return new Promise(resolve => {
      setTimeout(() => resolve(), timeout)
    })
  },

  waitUntil(condition) {
    return new Promise(resolve => {
      const interval = setInterval(() => {
        if (condition()) {
          clearInterval(interval)
          resolve()
        }
      }, 10)
    })
  },

  fetchLottie(url) {
    return window.lottieCache[url] || url
  },

  isDev() {
    return process.env.NODE_ENV === "development"
  },

  isStaging() {
    return /gamestore-dev/gi.test(document.location.hostname)
  },
}

export default utils
